import React from 'react';
import { EMPTY } from 'utils/atomUtils';
import PackageTypePicker from 'components/forms/bookingWidget/PackageTypePicker';
import { Boat } from 'swagger/models';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import {
  bookingDurationAtom,
  bookingTripTimeAtom,
  isBookingMultiDayAtom,
  tripFinishDayjsAtom,
  tripStartDayjsAtom,
} from 'components/forms/bookingWidget/jotaiStore';

interface CaptainPackageInputProps {
  boatDetails: Boat;
}
export default ({ boatDetails }: CaptainPackageInputProps) => {
  const isBookingMultiDay = useAtomValue(isBookingMultiDayAtom);
  const [bookingDuration, setBookingDuration] = useAtom(bookingDurationAtom);
  const [, setTripTime] = useAtom(bookingTripTimeAtom);
  const [, setTripStart] = useAtom(tripStartDayjsAtom);
  const setTripFinish = useSetAtom(tripFinishDayjsAtom);

  return (
    <PackageTypePicker
      onChange={(packageType) => {
        // reset duration and time if the new package type doesn't have the previous package
        if (!packageType[bookingDuration?.name]) {
          setBookingDuration(EMPTY);
          setTripTime(EMPTY);
          if (isBookingMultiDay) {
            setTripStart(EMPTY);
            setTripFinish(EMPTY);
          }
        }
      }}
      captainStatus={boatDetails.captain_option}
    />
  );
};
